/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyDriver
 */
export interface ReadOnlyDriver {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyDriver
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDriver
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDriver
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyDriver
     */
    readonly clientId?: string;
}

export function ReadOnlyDriverFromJSON(json: any): ReadOnlyDriver {
    return ReadOnlyDriverFromJSONTyped(json, false);
}

export function ReadOnlyDriverFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyDriver {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'surname': json['surname'],
        'clientId': !exists(json, 'client_id') ? undefined : json['client_id'],
    };
}

export function ReadOnlyDriverToJSON(value?: ReadOnlyDriver | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'surname': value.surname,
    };
}


